import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AccountsTable from "./accountsTable";
import Pagination from "../../components/common/pagination";
import { getAccounts, deleteAccount, getCounters } from "../../services/accountService";
import CounterCards from "../../components/common/countercards";
import SearchBox from "../../components/searchBox";
import { getServices } from "../../services/servicesService";
import LoadingIndicator from "../../components/common/LoadingIndicator";

class Accounts extends Component {
  state = {
    accounts: [],
    currentPage: 1,
    pageSize: 10,
    searchQuery: "",
    sortColumn: { path: "id", order: "desc" },
    serviceList: [],
    cards: [
      { 
        path: "total",
        name: "Total", 
        number: "", 
        icon: <i className="fa fa-code-fork" />, 
        background: "primary" 
      },
      { 
        path: "active",
        name: "Active", 
        number: "", 
        icon: <i className="fa fa-ticket" />, 
        background: "danger" 
      
      },
      { 
        path: "online",
        name: "Online", 
        number: "", 
        icon: <i className="fa fa-database" />, 
        background: "success" 
      },
      { 
        path: "recent",
        name: "Recent", 
        number: "", 
        icon: <i className="fa fa-users" />, 
        background: "info" 
      },
    ],
    loading: true,
    totalCount: 0,
  };

  formatDate (date) {
    const formatted = moment(date).format("Do MMM. YYYY").toString();
    return formatted;
  }

  async populateServiceList () {
    const response = await getServices({ page: 1, pageSize: 1000 });
    const payload = response?.data;
    const serviceList = Array.isArray(payload) ? payload : (payload?.data || []);
    this.setState({ serviceList });
  };

  async populateCounters () {
    // const { data: counters } = await getCounters();
    // const Cards = this.state.cards.map(obj => {
    //   return {...obj, 
    //     number: counters.find(c => c.name === obj.path).number,
    //   };
    // });
    // this.setState({ cards: Cards });  
  }

  async componentDidMount() {
    await this.populateServiceList ();

    await this.populateAccounts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location?.state?.refreshToken !== this.props.location?.state?.refreshToken) {
      this.setState({
        currentPage: 1,
        searchQuery: "",
        sortColumn: { path: "id", order: "desc" },
        loading: true,
      }, () => {
        this.populateAccounts();
      });
    }
  }

  populateAccounts = async () => {
    try {
      if (!this.state.loading) this.setState({ loading: true });

      const { currentPage, pageSize, searchQuery, sortColumn } = this.state;

      const params = {
        page: currentPage,
        pageSize,
        sortBy: sortColumn.path,
        sortOrder: sortColumn.order.toUpperCase(),
      };
      if (searchQuery) params.search = searchQuery;

      const response = await getAccounts(params);
      const payload = response?.data;
      const accounts = Array.isArray(payload) ? payload : (payload?.data || []);
      const totalCount = Array.isArray(payload) ? accounts.length : (payload?.pagination?.totalCount || 0);

      const Accounts = accounts.map(obj => {
        const service = this.state.serviceList.find(s => s.id === parseInt(obj.srvid));
        return {
          ...obj,
          createdAt: this.formatDate(obj.createdAt),
          expiration: this.formatDate(obj.expiration),
          expires: obj.expiration ? moment(obj.expiration).fromNow() : '',
          service: service?.name,
          enableuser: obj.enableuser ? "Active" : "Inactive",
          isOnline: obj.lastactive ? moment().diff(obj.lastactive, 'minutes') < 5 : false,
        };
      });

      this.setState({ accounts: Accounts, totalCount, loading: false });
    } catch (ex) {
      console.error('Error fetching accounts:', ex);
      toast.error('Failed to load accounts');
      this.setState({ loading: false });
    }
  };

  handleDelete = async account => {
    const originalAccounts = this.state.accounts;
    const accounts = originalAccounts.filter(a => a.username !== account.username);
    this.setState({ accounts });

    try {
      await deleteAccount(account.username);
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast.error("This account has already been deleted.");

      this.setState({ account: originalAccounts });
    }
  };

  handleLike = account => {
    const accounts = [...this.state.accounts];
    const index = accounts.indexOf(account);
    accounts[index] = { ...accounts[index] };
    accounts[index].liked = !accounts[index].liked;
    this.setState({ accounts });
  };

  handlePageChange = page => {
    this.setState({ currentPage: page, loading: true }, this.populateAccounts);
  };

  handleGenreSelect = genre => {
    this.setState({ selectedGenre: genre, searchQuery: "", currentPage: 1 });
  };

  handleSearch = query => {
    this.setState({ searchQuery: query, selectedGenre: null, currentPage: 1, loading: true }, this.populateAccounts);
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn, loading: true }, this.populateAccounts);
  };

  render() {
    const { pageSize, currentPage, sortColumn, searchQuery } = this.state;
    const { user } = this.props;

    const { accounts, totalCount } = this.state;

    return (
      <React.Fragment>
        {/* <CounterCards cards={this.state.cards} />
        <hr className="m-3" /> */}
        <div className="row">
          <div className="col">
            {this.state.loading && <LoadingIndicator message="Loading accounts..." />}
            {!this.state.loading &&
            <div>
              <p>You have {totalCount ? totalCount : "no"} account{(totalCount>1 || totalCount===0) && "s"}.</p>
            </div>}
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
            <AccountsTable
              accounts={accounts}
              filters={{ searchQuery, sortColumn }}
              sortColumn={sortColumn}
              onLike={this.handleLike}
              onDelete={this.handleDelete}
              onSort={this.handleSort}
            />
            <Pagination
              itemsCount={totalCount}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={this.handlePageChange}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Accounts;